import React from "react"
import Layout4 from './../components/layout/layout-4';
import SEO from './../components/seo/seo'
import Realign from "../components/realign";

function realign() {
    return (
    <Layout4>
        <SEO title="Realign" />
        <Realign />
    </Layout4>
    )
}

export default realign
